// Synchronizacja flag sesji w localStorage z GET /api/whoami — wydzielone
// z App.js (AppWrapper.syncSession), żeby kontrakt był testowalny jednostkowo.
//
// Kontrakt (regresja flaky demo_banner.cy.js, PR #51): flagi sesji wolno
// kasować WYŁĄCZNIE po odpowiedzi serwera !res.ok (401). Odrzucony fetch
// (błąd sieci — w tym fetch przerwany unloadem przy pełnej nawigacji,
// odrzucany przez przeglądarkę jako "TypeError: Failed to fetch") nie mówi
// nic o ważności sesji: zapis z umierającego okna trafia do localStorage
// nowego okna i „wylogowałby" użytkownika mimo ważnego cookie sid.

import { zapiszFlagePrzerwy } from './kontoWPrzerwie';

// `/scan/` to skaner na telefonie: telefon z definicji NIE ma sesji panelu, a przekierowanie
// na logowanie zamieniało link z kodu QR w ekran „Zaloguj się”.
export const SESSION_PUBLIC_PATHS = ['/activate/', '/reset-password/', '/login', '/payments/thank-you', '/scan/'];

function readCookie(name, doc) {
  if (!doc) return '';
  const v = doc.cookie.split(';').map(c => c.trim()).find(c => c.startsWith(name + '='));
  return v ? decodeURIComponent(v.split('=').slice(1).join('=')) : '';
}

// Flagi uprawnień, firmy i planu z odpowiedzi /api/whoami (App.js, start aplikacji). Plan tylko,
// gdy serwer go podał: bez tego zmiana planu w trakcie sesji (do 90 dni) docierała do panelu
// dopiero po ponownym zalogowaniu, a starszy serwer albo atrapa bez pola nie nadpisze go „basic”.
export function zapiszFlagiSesji(storage, user = {}) {
  const u = user || {};
  storage.setItem('isAdmin', u.isAdmin ? '1' : '0');
  storage.setItem('isSuperAdmin', u.isSuperAdmin ? '1' : '0');
  storage.setItem('organizationId', u.organizationId ? String(u.organizationId) : '');
  storage.setItem('isDemo', u.isDemo ? '1' : '0');
  // F.11: przerwa w sezonie (konto tylko do odczytu), dla ekranów bez kontekstu przerwy.
  zapiszFlagePrzerwy(storage, u);
  if (typeof u.subscriptionPlan === 'string' && u.subscriptionPlan) {
    storage.setItem('subscriptionPlan', u.subscriptionPlan);
  }
}

export async function syncSessionFromWhoami({
  apiBase,
  navigate,
  fetchImpl = (...args) => fetch(...args),
  storage = window.localStorage,
  getPathname = () => window.location.pathname,
  getCsrfCookie = () => readCookie('csrf', typeof document === 'undefined' ? null : document),
  isMounted = () => true,
}) {
  try {
    const res = await fetchImpl(`${apiBase}/api/whoami`, {
      method: 'GET',
      credentials: 'include'
    });
    if (!isMounted()) return;
    if (!res.ok) {
      // brak sesji — wyczyść lokalne dane i wymuś login (chyba że jesteśmy na publicznej stronie)
      const isPublic = SESSION_PUBLIC_PATHS.some(p => getPathname().startsWith(p));
      storage.removeItem('csrfToken');
      storage.removeItem('isLoggedIn');
      if (!isPublic) navigate('/login', { replace: true });
      return;
    }
    const j = await res.json().catch(() => ({}));
    // jeśli serwer zwraca csrfToken — zsynchronizuj
    if (j.csrfToken) {
      if (storage.getItem('csrfToken') !== j.csrfToken) {
        storage.setItem('csrfToken', j.csrfToken);
      }
    } else {
      // fallback: jeśli backend nie zwróci tokenu, spróbuj odczytać ciasteczko csrf (jeśli dostępne)
      const cookieCsrf = getCsrfCookie();
      if (cookieCsrf && storage.getItem('csrfToken') !== cookieCsrf) {
        storage.setItem('csrfToken', cookieCsrf);
      }
    }
    if (j.userId) {
      storage.setItem('userId', String(j.userId));
      storage.setItem('isLoggedIn', 'true');
      // Zsynchronizuj dane użytkownika i organizacji
      if (j.user) {
        storage.setItem('userFirstName', j.user.firstname || '');
        storage.setItem('userLastName', j.user.lastname || '');
        storage.setItem('organizationName', j.user.organizationName || '');
      }
    }
  } catch (e) {
    // Błąd sieci nie dowodzi nieważności sesji — nic nie kasujemy i nie
    // przekierowujemy (patrz kontrakt w nagłówku pliku).
  }
}
